export default "__VITE_ASSET__C8DhoS2c__"